export default "__VITE_ASSET__BgxsCC85__"